module.exports = __webpack_public_path__ + "media/images/keyVisual_mobile_en-77f2f72eaafe3e189ef69f11774ea0e4.jpg";